
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { UniversitySpecialityResponse } from "../../models/dtos";

export const universitySpecialitiesApi = createApi({
  reducerPath: 'universitySpecialitiesApi',
  baseQuery: baseAuthQuery('UniversitySpecialities'),
  tagTypes: ['UniversitySpeciality'],
  endpoints: (builder) => ({
    getUniversitySpecialities: builder.query<ApiResponse<UniversitySpecialityResponse[]>, void>({
      query: () => "",
      providesTags: ['UniversitySpeciality'],
    }),
    getUniversitySpecialityById: builder.query<ApiResponse<UniversitySpecialityResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['UniversitySpeciality'],
    }),
    updateUniversitySpeciality: builder.mutation<ApiResponse<UniversitySpecialityResponse>, Partial<UniversitySpecialityResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['UniversitySpeciality'],
    }),
    deleteUniversitySpeciality: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['UniversitySpeciality'],
    }),
  }),
});
